import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { DepositLimitType } from "@obg/ngx.core";
import { ConfigService } from "@obg/ngx.global";
import { Observable } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class ResponsibleGamingUiConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getTimeOffEnabled$(): Observable<boolean | undefined> {
		return this.configService.get$((x) => x.commonUi.responsibleGaming.isTimeOffEnabled, false);
	}

	getDepositLimitEnabled$(): Observable<boolean | undefined> {
		return this.configService.get$((x) => x.commonUi.responsibleGaming.isDepositLimitEnabled, true);
	}

	getNetDepositLimitEnabled$(): Observable<boolean | undefined> {
		return this.configService.get$((x) => x.commonUi.responsibleGaming.isNetDepositLimitEnabled, false);
	}

	getDepositLimitCalculatorEnabled$(): Observable<boolean | undefined> {
		return this.configService.get$((x) => x.commonUi.responsibleGaming.isDepositLimitCalculatorEnabled, false);
	}

	getShowDepositLimitDeleteBtn(): boolean {
		return this.configService.get((x) => x.commonUi.responsibleGaming.showDepositLimitDeleteBtn, true);
	}

	getSelfExclusionEnabled$(): Observable<boolean | undefined> {
		return this.configService.get$((x) => x.commonUi.responsibleGaming.isSelfExclusionEnabled, true);
	}

	getIndefiniteSelfExclusionTabEnabled$(): Observable<boolean | undefined> {
		return this.configService.get$((x) => x.commonUi.responsibleGaming.isIndefiniteSelfExclusionTabEnabled, false);
	}

	getBalanceLimitEnabled$(): Observable<boolean | undefined> {
		return this.configService.get$((x) => x.commonUi.responsibleGaming.isBalanceLimitEnabled, false);
	}

	getBettingLimitEnabled$(): Observable<boolean | undefined> {
		return this.configService.get$((x) => x.commonUi.responsibleGaming.isBettingLimitEnabled, false);
	}

	getBettingLimitV2Enabled$(): Observable<boolean | undefined> {
		return this.configService.get$((x) => x.commonUi.responsibleGaming.isBettingLimitV2Enabled, false);
	}

	getIsTimedWageringLimit$(): Observable<boolean | undefined> {
		return this.configService.get$((x) => x.commonUi.responsibleGaming.isTimedWageringLimit, false);
	}

	getNetlossLimitEnabled$(): Observable<boolean | undefined> {
		return this.configService.get$((x) => x.commonUi.responsibleGaming.isNetLossLimitEnabled, false);
	}

	getLogoutCooldownEnabled$(): Observable<boolean | undefined> {
		return this.configService.get$((x) => x.commonUi.responsibleGaming.isLogoutCooldownLimitEnabled, false);
	}

	getLoginLimitEnabled$(): Observable<boolean | undefined> {
		return this.configService.get$((x) => x.commonUi.responsibleGaming.isLoginLimitEnabled, false);
	}

	getDepositLimitType(): DepositLimitType {
		return this.configService.get(
			(x) => x.commonUi.responsibleGaming.depositLimitType as DepositLimitType,
			DepositLimitType.ResponsibleGaming
		);
	}

	getShowBettingLimitDeleteBtn(): boolean {
		return this.configService.get((x) => x.commonUi.responsibleGaming.showBettingLimitDeleteBtn, false);
	}

	getShowNetlossLimitDeleteBtn(): boolean {
		return this.configService.get((x) => x.commonUi.responsibleGaming.showNetlossLimitDeleteBtn, false);
	}

	getDepositLimitSuffixed(): boolean {
		return this.configService.get((x) => x.commonUi.responsibleGaming.isDepositLimitSuffixed, false);
	}

	getShowDepositLimitUpcomingChangeUndoBtn(): boolean {
		return this.configService.get((x) => x.commonUi.responsibleGaming.showDepositLimitUpcomingChangeUndoBtn, false);
	}

	getShowNotificationIcon(): boolean {
		return this.configService.get((x) => x.commonUi.responsibleGaming.showNotificationIcon, false);
	}

	getShouldShowMoreInfo(): boolean {
		return this.configService.get((x) => x.commonUi.responsibleGaming.showMoreInfo, false);
	}

	getShouldSplitLimitSetText(): boolean {
		return this.configService.get((x) => x.commonUi.responsibleGaming.splitLimitSetText, false);
	}

	getShowLightExclamationIcon(): boolean {
		return this.configService.get((x) => x.commonUi.responsibleGaming.showLightExclamationIcon, false);
	}

	getDepositLimitControlsEnabled(): boolean {
		return this.configService.get((x) => x.commonUi.responsibleGaming.isDepositLimitControlsEnabled, true);
	}

	getNetDepositLimitControlsEnabled(): boolean {
		return this.configService.get((x) => x.commonUi.responsibleGaming.isNetDepositLimitControlsEnabled, false);
	}

	showDepositLimitConfirmModal(): boolean {
		return this.configService.get((x) => x.commonUi.responsibleGaming.showDepositLimitConfirmModal, false);
	}

	showBettingLimitConfirmModal(): boolean {
		return this.configService.get((x) => x.commonUi.responsibleGaming.showBettingLimitConfirmModal, false);
	}

	getHideInputHint(): boolean {
		return this.configService.get((x) => x.commonUi.responsibleGaming.hideInputHint, false);
	}
}
